import { postData } from "../../../fetch";

// muutospyynto.tallennus.tallennaJarjestamislupa
export const tallennaJarjestamislupa = () => ({
  label: "Järjestämisluvan tallennus",
  input: ["jarjestamislupa", "muutospyynto", "inform"],
  run: async ({ jarjestamislupa, muutospyynto, inform }) => {
    const formData = new FormData();
    const muutos = new Blob([JSON.stringify(muutospyynto)], {
      type: "application/json"
    });
    formData.append("muutospyynto", muutos);
    formData.append(
      jarjestamislupa.tiedostoId,
      jarjestamislupa.tiedosto,
      jarjestamislupa.filename
    );
    const response = await postData("tallennaJarjestamislupa", formData, {
      urlEnding: muutospyynto.uuid
    });
    const json = response && response.ok ? await response.json() : {};
    return {
      inform,
      result: json,
      status: response.status
    };
  },
  next: output => {
    if (output.inform !== false) {
      if (output.status === 200) {
        return ["muutospyynto.tallennus.onnistui"];
      } else if (output.status !== 200) {
        return ["muutospyynto.tallennus.epaonnistui"];
      }
    }
  }
});
